var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-form", {
    staticClass: "box is-paddingless",
    attrs: { form: _vm.form, rules: _vm.rules },
    scopedSlots: _vm._u([
      {
        key: "fields",
        fn: function(ref) {
          var fields = ref.fields
          return [
            _c(
              "sc-field",
              { attrs: { label: "Importar arquivo", prop: "file" } },
              [
                _c(
                  "sc-files-upload",
                  _vm._b(
                    {
                      ref: "fileImporterField",
                      on: {
                        addfilestart: function(file) {
                          return (fields.file = file)
                        },
                        removefile: function() {
                          return (fields.file = null)
                        }
                      }
                    },
                    "sc-files-upload",
                    _vm.fileImporterOptions,
                    false
                  )
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _c(
                  "strong",
                  [
                    _c("sc-icon", { attrs: { icon: "question-circle" } }),
                    _vm._v(" Quais colunas meu arquivo Excel precisa ter?")
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        Para baixar um arquivo de exemplo,\n        "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/static/examples/arquivo_exemplo_tag_xml_cte.xlsx",
                      download: ""
                    }
                  },
                  [_c("strong", [_vm._v("clique aqui")])]
                )
              ])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fff7ece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fff7ece","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-file-import/ScFileImport.vue
// module id = null
// module chunks = 